import VueRouter from 'vue-router'
import Vue from 'vue'
import myHome from "@/views/myHome.vue"
import myApp from "@/views/myApp.vue"
// 防止重复点击路由，导致提示避免到当前位置的冗余导航（路由冗余）解决方式
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
    return routerRePush.call(this, location).catch(error => error)
}
// 通过vue.use(插件)，安装插件
Vue.use(VueRouter)
// 创建路由对象
const routes = [
    {path: '/', component: myApp,
        children:[
            {path: '/home', name: "MyHome", component: myHome, meta: {title: '河北自贸区产业投资集团采购系统-电子招投标采购平台- 河北自贸区产业投资集团采购系统'}},
            {path: '/about', name: "myAbout", component: () => import("@/views/myAbout.vue"), meta: {title: '交易信息-河北自贸区产业投资集团采购系统'}},
            {path: '/myExpert', name: "Expert", component: () => import("@/views/myExpert.vue"), meta: {title: '平台专家库-河北自贸区产业投资集团采购系统'}},
            {path: '/download', name: "Download", component: () => import("@/views/myDownload.vue"), meta: {title: '下载中心-河北自贸区产业投资集团采购系统'}},
            {path: '/ggDetail', name: "ggDetail", component: () => import("@/views/ggDetail.vue"), meta: {title: '交易信息-详情-河北自贸区产业投资集团采购系统'}},
            {path: '/ourself', name: "OurSelf", component: () => import("@/views/ourSelf.vue"), meta: {title: '关于我们-河北自贸区产业投资集团采购系统'}},
            {path: '/collectGgDetail', name: "collectGgDetail", component: () => import("@/views/collectGgDetail.vue"), meta: {title: '征集公告-河北自贸区产业投资集团采购系统'}},
        ]
    },
    {path:'/login', name:'loginMain', component:()=>import("@/views/LoginMain.vue"),meta: {title: '登录-河北自贸区产业投资集团采购系统'}},
  {path:'/superviseLinks', name:'superviseLinks', component:()=>import("@/views/superviseLinks.vue"),meta: {title: '监督/资审通道'}},
    {path:'/register', name:'RegisterMain', component:()=>import("@/views/RegisterMain.vue"), meta: {title: '注册-河北自贸区产业投资集团采购系统'}},
    {path:'/agentRegister', name:'agentRegister', component:()=>import("@/views/agentRegister.vue"), meta: {title: '河北自贸区产业投资集团采购系统-代理注册'}},
    {path:'*',redirect:'/home'},
    {path:'/eat', name: 'ExtAppTokenHandler', component: () => import("@@/components/ExtAppTokenHandler"),meta: {title: '外不跳转'}},
   {path: '/vendorRegister', name: 'vendorRegisterMain', component: () => import("@/views/vendorRegisterMain.vue"), meta: {title: '供应商入库-河北自贸区产业投资集团采购系统'}},
]
const router = new VueRouter({
    // 配置URL和组价直接的映射关系
    routes,
    // history模式
    mode: 'history'
})
// 将router对象传入到vue实例中
export default router
